import { render } from "./InvoiceDetailsForm.vue?vue&type=template&id=1196c7d7"
import script from "./InvoiceDetailsForm.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__